import Mock from 'mockjs'

// 商品列表
const MOCK030004 = Mock.mock({
    'respCode': 0,
    'respMsg': '',
    'respData': {
        'addressList': [
            {
                'name':'绿地香港上海公司',
                'provinceName':'中国',
                'cityName': '上海',
                'districtName': '浦东新区',
                'address': '商城路506号新梅联合广场B座 23楼',
                'mobileNo': '15158115817',
                'default':true
            },
            {
                'name':'香港绿地上海公司',
                'provinceName':'巴尔坦星球',
                'cityName': '泰坦',
                'districtName': '浦东新区',
                'address': '商城路506号新梅联合广场B座 23楼',
                'mobileNo': '13158654546',
                'default':false
            },
            {
                'name':'哈哈哈哈',
                'provinceName':'巴尔坦星球',
                'cityName': '泰坦',
                'districtName': '浦东新区',
                'address': '商城路506号新梅联合广场B座 23楼',
                'mobileNo': '13158654546',
                'default':false
            }
        ]
    }
});

export default MOCK030004


// WEBPACK FOOTER //
// ./src/mock/getAddressList.js